import { twJoin } from 'tailwind-merge';

import Text from 'shopper/components/Text';

import APP from 'constants/app';
import FOOTER from 'constants/footer';

const ITEMS = [FOOTER.INFO, APP.ADDRESS.COMPLETE_ADDRESS, FOOTER.COPYRIGHT];

const FooterBottom = () => (
  <div className="flex w-full flex-col flex-wrap items-center justify-center px-1 py-4 md:max-w-[640px] md:gap-1 lg:max-w-2xl">
    {ITEMS.map((item, index) => (
      <Text
        key={item}
        className={twJoin(
          'text-center md:text-left',
          index !== 0 && 'mt-2 md:mt-0'
        )}
        size="size3"
      >
        {item}{' '}
      </Text>
    ))}
  </div>
);

export default FooterBottom;
